import { useCustomNavigation } from "@app/components/navigation/NavigationHandler"
import { useViewport } from "@tecreation/funnel-components"
import "./AnimatedRoute.css"

export default function AnimatedRoute({ children, style, className }) {
	const { sm, md } = useViewport()

	const { action, animation } = useCustomNavigation()
	//We apply a empty animation with random values to secure that a page without transition get removed on the next transition effect
	//If we jump to a page A without a transition then page A dont get removed if we jump with a transition to next page B
	const appliedAnimation =
		(sm || md) && animation && Animations[animation]
			? Animations[animation][action === "PUSH" || action === "REPLACE" ? "forwards" : "backwards"]
			: Animations.empty

	//we apply a m.div also we don't have a animation to handle exit animations from screen that did come in without a animation. Otherwise the screen would not have a exit animation
	//while the new screen enters with a animation
	// const MOTION = sm || md ? m.div : "div";
	const MOTION = "div"

	return (
		<MOTION
			className={"animatedRoute " + " " + (animation === AnimationTypes.stack ? "animation__stack" : "") + " " + className}
			{...appliedAnimation}
			style={style}
		>
			{children}
		</MOTION>
	)
}

const Animations = {
	//only to fix the issue that the animations goes wrong if we had a transition without an animation before
	empty: {
		initial: {
			transform: "translateX(100%)",
			position: "absolute",
			zIndex: 1,
		},
		animate: {
			transform: "translateX(0)",
			position: "absolute",
			transitionEnd: { position: "unset" },
		},
		exit: { transform: "translateX(-10%)", position: "absolute" },
		transition: {
			type: "tween",
			stiffness: 100,
			duration: 0,
			ease: "easeInOut",
		},
	},
	slide: {
		forwards: {
			initial: {
				transform: "translateX(100%)",
				position: "absolute",
				zIndex: 1,
			},
			animate: {
				transform: "translateX(0)",
				position: "absolute",
			},
			exit: { transform: "translateX(-10%)", position: "absolute" },
			transition: {
				type: "tween",
				stiffness: 100,
				duration: 0.3,
				ease: "easeInOut",
			},
		},
		backwards: {
			initial: { transform: "translateX(-10%)", position: "absolute" },
			animate: {
				transform: "translateX(0)",
				position: "absolute",
				transitionEnd: { position: "unset" },
			},
			exit: {
				transform: "translateX(100%)",
				position: "absolute",
				zIndex: 2,
			},
			transition: {
				type: "tween",
				stiffness: 100,
				duration: 0.3,
				ease: "easeInOut",
			},
		},
	},
	stack: {
		forwards: {
			initial: {
				transform: "translateY(100%)",
				position: "absolute",
				top: 0,
				zIndex: 2,
			},
			animate: {
				transform: "translateY(0%)",
				position: "absolute",
				top: 0,
				zIndex: 2,
				transition: {
					ease: "easeInOut",
					delay: 0.1,
					duration: 0.4,
				},
				transitionEnd: { position: "unset" },
			},
			exit: {
				transform: "scale(.7)",
				top: 0,
				transition: {
					ease: "easeOut",
					transform: { duration: 0.3 },
					top: { delay: 0.1 },
				},
			},
		},
		backwards: {
			initial: { transform: "scale(.7)", top: 0 },
			animate: {
				transform: "scale(1)",
				top: 0,
				transition: {
					ease: "easeOut",
					transform: { duration: 0.3, delay: 0 },
				},
			},
			exit: {
				transform: "translateY(100%)",
				position: "absolute",
				top: 0,
				zIndex: 2,
				transition: { duration: 0.4 },
			},
		},
	},
}

const AnimationTypes = {
	slide: "slide",
	stack: "stack",
}

export { AnimationTypes }
